export class FilterFicheTechniqueModel {
  majPlat: boolean;
  page: number;
  size: number;
  idUdp: number;
  progress: number;
  batchSize: number;
  numberOfDishesProduced: number;
  idsPlat: number[] = [];
}
